import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { formatNumber } from 'src/utils/helperFunctions';

interface Props extends GridCellProps {
  uomField: string;
}

const UomCell: FC<React.PropsWithChildren<Props>> = ({ dataItem, colSpan, columnIndex, isSelected, ariaColumnIndex, className, style, field, format, uomField }) => (
  <td
    colSpan={colSpan}
    className={className}
    role="gridcell"
    aria-colindex={ariaColumnIndex}
    aria-selected={isSelected}
    data-grid-col-index={columnIndex}
    style={{ ...style, textAlign: 'right' }}
  >
    {formatNumber(dataItem[field], format)} <span className="uom">{dataItem[uomField]}</span>
  </td>
);

export default UomCell;
